export const PAGE_NOT_FOUND = "ld.common.pageNotFound";
export const CONTATTI = "ld.common.contatti";
export const FAQ = "ld.common.faq";
export const INFORMATIVA_TRATTAMENTO_DATI = "ld.common.trattamentoDati";
export const LINGUA_INGLESE = "ld.common.linguaInglese";
export const LINGUA_ITALIANA = "ld.common.linguaItaliana";
export const EMPTY_MESSAGE = "ld.common.emptyMessage";
//Label per l'installationDrawer
export const INSTALLAZIONE_HEADER = "ld.installazione.header";
export const INSTALLAZIONE_ISTRUZIONI1 = "ld.installazione.istruzioni1";
export const INSTALLAZIONE_ISTRUZIONI2 = "ld.installazione.istruzioni2";
export const INSTALLAZIONE_ISTRUZIONI3 = "ld.installazione.istruzioni3";
export const INSTALLAZIONE_ISTRUZIONI4 = "ld.installazione.istruzioni4";

export const NESSUN_OSPEDALE_TITLE = "ld.notification.nessunOspedaleTitle";
export const NESSUN_OSPEDALE_MESSAGE = "ld.notification.nessunOspedaleMessage";
export const SELECT_PLACEHOLDER = "ld.form.selectPlaceholder";
export const INPUT_PLACEHOLDER = "ld.form.inputPlaceholder";
//Label per pagina di ricerca
export const AZIENDA_SANITARIA_LABEL = "ld.ricerca.aziendaSanitariaLabel";
export const AZIENDA_SANITARIA_MESSAGE = "ld.ricerca.aziendaSanitariaMessage";
export const AZIENDA_SANITARIA_PLACEHOLDER = "ld.ricerca.aziendaSanitariaPlaceholder";
export const STRUTTURA_SANITARIA_LABEL = "ld.ricerca.strutturaSanitariaLabel";
export const STRUTTURA_SANITARIA_MESSAGE = "ld.ricerca.strutturaSanitariaMessage";
export const STRUTTURA_SANITARIA_PLACEHOLDER = "ld.ricerca.strutturaSanitariaPlaceholder";
export const ID_PAZIENTE_LABEL = "ld.ricerca.idPazienteLabel";
export const ID_PAZIENTE_MESSAGE = "ld.ricerca.idPazienteMessage";
export const ID_PAZIENTE_PLACEHOLDER = "ld.ricerca.idPazientePlaceholder";
export const ACCEDI = "ld.ricerca.accedi";
export const RESET = "ld.ricerca.reset";
export const ACQUISIZIONE_FOTOCAMERA = "ld.ricerca.acquisizioneFotocamera";
export const SPINNING_INTERVENTO = "ld.ricerca.spinningIntervento";
export const QR_CODE_ERRATO_TITLE = "ld.ricerca.qrCodeErratoTitle";
export const QR_CODE_ERRATO_MESSAGE = "ld.ricerca.qrCodeErratoMessage";
export const INTERVENTO_204_TITLE = "ld.ricerca.intervento204Title";
export const INTERVENTO_204_MESSAGE = "ld.ricerca.intervento204Message";
export const INTERVENTO_NUOVI_DATI_TITLE = "ld.ricerca.interventoNuoviDatiTitle";
export const INTERVENTO_NUOVI_DATI_MESSAGE = "ld.ricerca.interventoNuoviDatiMessage";
export const SERVIZIO_NON_DISPONIBILE_TITLE = "ld.ricerca.servizioNonDisponibileTitle";
export const SERVIZIO_NON_DISPONIBILE_MESSAGE = "ld.ricerca.servizioNonDisponibileMessage";
//Label per pagina di monitoraggio
export const LEGENDA = "ld.monitora.legendaLabel";
export const NON_INIZIATO_LABEL = "ld.monitora.nonIniziato";
export const IN_CORSO_LABEL = "ld.monitora.inCorso";
export const CONCLUSO_LABEL = "ld.monitora.concluso";
export const ID_PAZIENTE_TITLE = "ld.monitora.idPazienteTitle";
export const DATA_INTERVENTO_TITLE = "ld.monitora.dataInterventoTitle";
export const STATO_NON_DISPONIBILE = "ld.monitora.statoNonDisponibile";
export const STATO_INTERVENTO_PIANIFICATO = "ld.monitora.statoInterventoPianificato";
export const STATO_IN_BLOCCO_OPERATORIO = "ld.monitora.statoInBloccoOperatorio";
export const STATO_INTERVENTO_IN_CORSO = "ld.monitora.statoInterventoInCorso";
export const STATO_INTERVENTO_POST_OPERATORIO = "ld.monitora.statoInterventoPostOperatorio";
export const STATO_INTERVENTO_TERMINATO = "ld.monitora.statoInterventoTerminato";
export const INGRESSO_BLOCCO_OPERATORIO_LABEL = "ld.monitora.ingressoBloccoOperatorio";
export const INGRESSO_SALA_OPERATORIA_LABEL = "ld.monitora.ingressoSalaOperatoria";
export const USCITA_SALA_OPERATORIA_LABEL = "ld.monitora.uscitaSalaOperatoria";
export const USCITA_BLOCCO_OPERATORIO_LABEL = "ld.monitora.uscitaBloccoOperatorio";
export const LAST_UPDATE_LABEL = "ld.monitora.lastUpdate";
